export default {
  'menu.crm.nav.performance': '業績',
  'menu.crm.performance.overview': '業績概要',
  'menu.crm.performance.targets': '目標管理',
  'menu.crm.performance.entries': '業績明細',
  'menu.crm.performance.splits': '業績配分',
  'menu.crm.performance.team': 'チーム達成',
  'menu.crm.performance.reconciliation': '照合と締め',

  'menu.crm.scope.my': '自分の担当',
  'menu.crm.scope.team': '部下の担当',
  'menu.crm.scope.collab': '共同担当',
  'menu.crm.scope.followed': 'フォロー中',
  'menu.crm.scope.all': 'すべて',
  'menu.crm.page.overview': '概要',
  'menu.crm.page.approval': '承認',
  'menu.crm.page.calendar': 'カレンダー',
  'menu.crm.page.business-trip': '出張アシスタント',
  'menu.crm.page.task': 'タスク',
  'menu.crm.page.follow-up': 'フォロー',
  'menu.crm.page.attachment': '添付ファイル',
  'menu.crm.page.lead-source': '流入元分析',

  'menu.crm.help': 'ヘルプ',
  'menu.crm.nav.workbench': 'ワークベンチ',
  'menu.crm.nav.marketing': 'マーケティング',
  'menu.crm.nav.lead': 'リード',
  'menu.crm.nav.customer': '顧客',
  'menu.crm.nav.contact': '連絡先',
  'menu.crm.nav.opportunity': '商談',
  'menu.crm.nav.quote': '見積',
  'menu.crm.nav.product': '製品',
  'menu.crm.nav.contract': '契約',
  'menu.crm.nav.receipt': '入金',
  'menu.crm.nav.analysis': '分析',
  'menu.zy-crm.products.catalog': '製品カタログ',
  'menu.zy-crm.workbench.overview': '概要',

  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
  'menu.zy-crm': '組織管理バックエンド',
  'menu.zy-crm.workbench': 'ワークスペース',
  'menu.zy-crm.workbench.dashboard': 'ダッシュボード',
  'menu.zy-crm.approvals': '承認センター',
  'menu.zy-crm.leadManagement': 'リード',
  'menu.zy-crm.leadManagement.lead.my': '担当分',
  'menu.zy-crm.leadManagement.lead.team': '部下担当分',
  'menu.zy-crm.leadManagement.lead.collab': '協業分',
  'menu.zy-crm.leadManagement.lead.pool': 'リードプール',
  'menu.zy-crm.leadManagement.lead.all': 'すべて',
  'menu.zy-crm.customerManagement': '顧客',
  'menu.zy-crm.customerManagement.customer.my': '担当分',
  'menu.zy-crm.customerManagement.customer.team': '部下担当分',
  'menu.zy-crm.customerManagement.customer.collab': '協業中',
  'menu.zy-crm.customerManagement.customer.pool': '顧客プール',
  'menu.zy-crm.customerManagement.customer.all': 'すべて',
  'menu.zy-crm.customerManagement.contact': '連絡先',
  'menu.zy-crm.customerManagement.contact.my': '担当分',
  'menu.zy-crm.customerManagement.contact.team': '部下担当分',
  'menu.zy-crm.customerManagement.contact.collab': '協業中',
  'menu.zy-crm.customerManagement.contact.all': 'すべて',
  'menu.zy-crm.customerManagement.contact.detail': '連絡先詳細',
  'menu.zy-crm.salesManagement': '商談',
  'menu.zy-crm.salesManagement.opportunity.my': '担当分',
  'menu.zy-crm.salesManagement.opportunity.followed': 'フォロー中',
  'menu.zy-crm.salesManagement.opportunity.team': '部下担当分',
  'menu.zy-crm.salesManagement.opportunity.collab': '協業中',
  'menu.zy-crm.salesManagement.opportunity.all': 'すべて',
  'menu.zy-crm.salesManagement.opportunity.pool': '商談プール',
  'menu.zy-crm.salesManagement.quote': '見積書',
  'menu.zy-crm.salesManagement.quote.my': '担当分',
  'menu.zy-crm.salesManagement.quote.team': '部下担当分',
  'menu.zy-crm.salesManagement.quote.collab': '協業中',
  'menu.zy-crm.salesManagement.quote.all': 'すべて',
  'menu.zy-crm.salesManagement.quote.detail': '見積詳細',
  'menu.zy-crm.salesManagement.product': '商品',
  'menu.zy-crm.salesManagement.product.detail': '商品詳細',
  'menu.zy-crm.contractAndReceipt': '契約と入金',
  'menu.zy-crm.contractAndReceipt.contract': '契約',
  'menu.zy-crm.contractAndReceipt.contract.detail': '契約詳細',
  'menu.zy-crm.contractAndReceipt.receipt': '入金',
  'menu.zy-crm.contractAndReceipt.receipt.detail': '入金詳細',
  'menu.zy-crm.contractAndReceipt.receipt-schedule': '入金予定',
  'menu.zy-crm.contractAndReceipt.receipt-schedule.detail': '入金予定詳細',
  'menu.zy-crm.contractAndReceipt.invoice': '請求書',
  'menu.zy-crm.contractAndReceipt.invoice.detail': '請求書詳細',
  'menu.zy-crm.contractAndReceipt.invoiceProfile': '請求情報',
  'menu.zy-crm.collaboration': '協同業務',
  'menu.zy-crm.collaboration.calendar': 'カレンダー',
  'menu.zy-crm.collaboration.followUps': 'フォローアップ記録',
  'menu.zy-crm.collaboration.tasks': 'タスクセンター',
  'menu.zy-crm.collaboration.attachments': '添付ファイルセンター',
  'menu.zy-crm.analytics': 'データ分析',
  'menu.zy-crm.analytics.leadSourceAnalysis': 'リードソース分析',
  'menu.zy-crm.analytics.businessMap': 'ビジネスマップ',
  'menu.zy-crm.analytics.governance': 'データガバナンス',
  'menu.zy-crm.settings.marketing': 'マーケティング設定',
  'menu.zy-crm.systemConfig': 'システム設定',
  'menu.zy-crm.systemConfig.general': '共通設定',
  'menu.zy-crm.systemConfig.lead': 'リード設定',
  'menu.zy-crm.systemConfig.customer': '顧客設定',
  'menu.zy-crm.systemConfig.opportunity': '商談設定',
  'menu.zy-crm.systemConfig.product': '商品設定',
  'menu.zy-crm.systemConfig.marketing': 'マーケティング設定',
  'menu.zy-crm.systemConfig.contract': '契約設定',
  'menu.zy-crm.systemConfig.permissions': '権限設定',
  'menu.zy-crm.systemConfig.taxonomies': 'タグ管理',
  'menu.zy-crm.systemConfig.automationRules': '自動化ルール',
  'menu.zy-crm.systemConfig.invoiceProfile': '請求情報',
  'menu.zy-crm.systemConfig.tavily': 'Tavily 設定',
  'menu.zy-crm.systemConfig.modelSettings': 'モデル設定',
  'menu.zy-crm.systemConfig.customerPoolConfigs': '顧客プール設定',
  'menu.zy-crm.systemConfig.leadPoolConfigs': 'リードプール設定',
  'menu.zy-crm.systemConfig.leadAssignRules': 'リード割り当てルール',
  'menu.zy-crm.systemConfig.customerLimitConfigs': '私池上限設定',
  'menu.zy-crm.systemConfig.dictionaryManagement': '辞書管理',
  'menu.zy-crm.systemConfig.productCategories': '商品カテゴリ',
  'menu.zy-crm.systemConfig.opportunityPipelines': '商談パイプライン',
  'menu.zy-crm.systemConfig.opportunityStages': '商談ステージ',
  'menu.zy-crm.systemConfig.areas': '地域設定',
  'menu.zy-crm.systemConfig.sourceChannels': '流入チャネル設定',
  'menu.zy-crm.systemConfig.marketingCampaignTypes': 'キャンペーン種別',
  'menu.zy-crm.systemConfig.marketingTouchpointTypes': '接点種別',
  'menu.zy-crm.systemConfig.industries': '業界設定',
  'menu.zy-crm.systemConfig.contractConfigs': '契約設定',
  'menu.zy-crm.systemConfig.contractCodeRules': '契約採番ルール',
  'menu.zy-crm.systemConfig.productCodeRules': '商品採番ルール',
  'menu.zy-crm.dashboard': 'ダッシュボード',
  'menu.zy-crm.calendar': 'カレンダー',
  'menu.zy-crm.lead': 'リード',
  'menu.zy-crm.lead.my': 'マイリード',
  'menu.zy-crm.lead.pool': 'リードプール',
  'menu.zy-crm.lead.all': 'すべてのリード',
  'menu.zy-crm.customer': '顧客',
  'menu.zy-crm.customer.my': 'マイ顧客',
  'menu.zy-crm.customer.pool': '顧客プール',
  'menu.zy-crm.customer.all': 'すべての顧客',
  'menu.zy-crm.contact': '連絡先',
  'menu.zy-crm.contact.detail': '連絡先詳細',
  'menu.zy-crm.opportunity': '商談',
  'menu.zy-crm.opportunity.my': '自分の商談',
  'menu.zy-crm.opportunity.all': 'すべての商談',
  'menu.zy-crm.opportunity.pool': '商談プール',
  'menu.zy-crm.opportunity.detail': '商談詳細',
  'menu.zy-crm.quote': '見積書',
  'menu.zy-crm.quote.detail': '見積詳細',
  'menu.zy-crm.product': '商品',
  'menu.zy-crm.product.detail': '商品詳細',
  'menu.zy-crm.contract': '契約',
  'menu.zy-crm.contract.detail': '契約詳細',
  'menu.zy-crm.receipt': '入金',
  'menu.zy-crm.receipt.detail': '入金詳細',
  'menu.zy-crm.receipt-schedule': '入金予定',
  'menu.zy-crm.receipt-schedule.detail': '入金予定詳細',
  'menu.zy-crm.invoice': '請求書',
  'menu.zy-crm.invoice.detail': '請求書詳細',
  'menu.zy-crm.invoiceProfile': '請求情報',
  'menu.zy-crm.followUps': 'フォローアップ記録',
  'menu.zy-crm.tasks': 'タスクセンター',
  'menu.zy-crm.attachments': '添付ファイルセンター',
  'menu.zy-crm.governance': 'データガバナンス',
  'menu.zy-crm.automationRules': '自動化ルール',
  'menu.zy-crm.analytics.leadSource': 'リードソース分析',
  'menu.zy-crm.permissions': 'データ権限',
  'menu.zy-crm.customerLimitConfigs': '私池上限設定',
  'menu.zy-crm.customerPoolConfigs': '顧客プール設定',
  'menu.zy-crm.leadPoolConfigs': 'リードプール設定',
  'menu.zy-crm.leadAssignRules': 'リード割り当てルール',
  'menu.zy-crm.sourceChannels': '流入チャネル設定',
  'menu.zy-crm.opportunityPipelines': '商談パイプライン',
  'menu.zy-crm.opportunityStages': '商談ステージ',
  'menu.zy-crm.areas': '地域設定',
  'menu.zy-crm.industries': '業界設定',
  'menu.zy-crm.contractConfigs': '契約設定',
  'menu.zy-crm.productCategories': '商品カテゴリ',
  'menu.zy-crm.contractCodeRules': '契約採番ルール',
  'menu.zy-crm.productCodeRules': '商品採番ルール',
  'menu.zy-crm.leads': 'リード',
  'menu.zy-crm.leads.overview': '概要',
  'menu.zy-crm.leads.my': '担当分',
  'menu.zy-crm.leads.team': '部下担当分',
  'menu.zy-crm.leads.pool': 'リードプール',
  'menu.zy-crm.leads.all': 'すべて',
  'menu.zy-crm.customers': '顧客',
  'menu.zy-crm.customers.overview': '概要',
  'menu.zy-crm.customers.my': '担当分',
  'menu.zy-crm.customers.team': '部下担当分',
  'menu.zy-crm.customers.collab': '協業中',
  'menu.zy-crm.customers.pool': '顧客プール',
  'menu.zy-crm.customers.all': 'すべて',
  'menu.zy-crm.contacts': '連絡先',
  'menu.zy-crm.contacts.overview': '概要',
  'menu.zy-crm.contacts.my': '担当分',
  'menu.zy-crm.contacts.team': '部下担当分',
  'menu.zy-crm.contacts.collab': '協業中',
  'menu.zy-crm.contacts.all': 'すべて',
  'menu.zy-crm.opportunities': '商談',
  'menu.zy-crm.opportunities.overview': '概要',
  'menu.zy-crm.opportunities.my': '担当分',
  'menu.zy-crm.opportunities.followed': 'フォロー中',
  'menu.zy-crm.opportunities.team': '部下担当分',
  'menu.zy-crm.opportunities.collab': '協業中',
  'menu.zy-crm.opportunities.pool': '商談プール',
  'menu.zy-crm.opportunities.all': 'すべて',
  'menu.zy-crm.quotes': '見積書',
  'menu.zy-crm.quotes.my': '担当分',
  'menu.zy-crm.quotes.team': '部下担当分',
  'menu.zy-crm.quotes.collab': '協業中',
  'menu.zy-crm.quotes.all': 'すべて',
  'menu.zy-crm.contracts': '契約',
  'menu.zy-crm.contracts.my': '担当分',
  'menu.zy-crm.contracts.team': '部下担当分',
  'menu.zy-crm.contracts.collab': '協業中',
  'menu.zy-crm.contracts.all': 'すべての契約',
  'menu.zy-crm.receipts': '入金',
  'menu.zy-crm.receipts.list': '入金',
  'menu.zy-crm.receipts.schedules': '入金予定',
  'menu.zy-crm.receipts.schedules.detail': '入金予定詳細',
  'menu.zy-crm.invoices': '請求書',
  'menu.zy-crm.invoices.detail': '請求書詳細',
  'menu.zy-crm.products': '商品',
  'menu.zy-crm.products.detail': '商品詳細',
  'menu.zy-crm.marketing': 'マーケティング活動',
  'menu.zy-crm.marketing.campaigns': '活動一覧',
  'menu.zy-crm.marketing.campaigns.detail': '活動詳細',
};
